import { oidcSettings } from '@src/config/oidc'
import jwtDecode from 'jwt-decode'
import { vuexOidcCreateStoreModule } from 'vuex-oidc'
const CryptoJS = require('crypto-js')
import { env } from '@/env'
let secretKey = env.VUE_APP_SECRET_KEY
async function saveState(key, state) {
  return new Promise(async (resolve, reject) => {
    try {
      const serializedState = JSON.stringify(state)
      var ciphertext = CryptoJS.AES.encrypt(serializedState, secretKey)
      // localStorage.setItem('state', ciphertext)
      window.localStorage.setItem(key, ciphertext)
      resolve('success')
    } catch (err) {
      console.log('Error while saving state' + err)
      // TODO: Logs
      // return 0
      reject(err)
    }
  })
}
const oidcStore = {
  oidcStore: vuexOidcCreateStoreModule(
    oidcSettings,
    // NOTE: If you do not want to use localStorage for tokens, in stead of just passing oidcSettings, you can
    // spread your oidcSettings and define a userStore of your choice
    // {
    //   ...oidcSettings,
    //   userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    // },
    // Optional OIDC store settings
    {
      namespaced: true,
      dispatchEventsOnWindow: true,
    },
    // Optional OIDC event listeners
    {
      userLoaded: (user) => {
        console.log('OIDC user is loaded:', user)
        localStorage.setItem('buildingLink.authToken', user.access_token)
        localStorage.setItem('refresh_token', user.refresh_token)
        saveState('auth.authToken', jwtDecode(user.access_token))
        saveState('auth.idToken', jwtDecode(user.id_token))
      },
      userUnloaded: () => {
        localStorage.clear()

        console.log('OIDC user is unloaded')
      },
      accessTokenExpiring: () => console.log('Access token will expire'),
      accessTokenExpired: () => console.log('Access token did expire'),
      silentRenewError: () => console.log('OIDC user is unloaded'),
      userSignedOut: () => {
        localStorage.clear()
        console.log('OIDC user is signed out')
      },
      oidcError: (payload) => console.log('OIDC error', payload),
    }
  ),
}

export default oidcStore
